import type { ReactElement } from 'react';
import { Navigate } from 'react-router-dom';
import { useCanAccessExplorerLab } from '../access';

interface ExplorerLabAccessGateProps {
  children: ReactElement;
}

export default function ExplorerLabAccessGate({ children }: ExplorerLabAccessGateProps) {
  const canAccessExplorerLab = useCanAccessExplorerLab();

  if (!canAccessExplorerLab) {
    return <Navigate to="/data/overview" replace />;
  }

  return children;
}